import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'
import { useTenant } from '../contexts/TenantContext'

import { isDemoTournament, getDemoPoules } from '../data/demoData'

export const usePoules = (tournamentId, divisionId = null) => {
  const { activeTenant } = useTenant()
  const [poules, setPoules] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (isDemoTournament(tournamentId)) {
      setPoules(getDemoPoules(tournamentId))
      setLoading(false)
      return
    }

    if (tournamentId && activeTenant) {
      fetchPoules()

      // Realtime Subscription for poules
      const channel = supabase
        .channel(`poules_live_${tournamentId}`)
        .on('postgres_changes', {
          event: '*',
          schema: 'public',
          table: 'poules',
          filter: `tournament_id=eq.${tournamentId}`
        }, () => {
          console.log('⚡ Realtime Poule Update Detected! Refetching...')
          fetchPoules()
        })
        .subscribe()

      return () => {
        supabase.removeChannel(channel)
      }
    }
  }, [tournamentId, divisionId, activeTenant])

  const fetchPoules = async () => {
    try {
      let query = supabase
        .from('poules')
        .select('*')
        .eq('tournament_id', tournamentId)
        .order('name')

      if (divisionId) {
        query = query.eq('division_id', divisionId)
      }

      const { data, error } = await query
      if (error) throw error
      setPoules(data || [])
    } catch (err) {
      console.error('Error fetching poules:', err)
    } finally {
      setLoading(false)
    }
  }

  const createPoule = async (pouleData) => {
    const { data, error } = await supabase
      .from('poules')
      .insert([{
        ...pouleData,
        tournament_id: tournamentId,
        tenant_id: activeTenant.id
      }])
      .select()
      .single()

    if (error) throw error
    setPoules([...poules, data])
    return data
  }

  const deletePoule = async (pouleId) => {
    const { error } = await supabase
      .from('poules')
      .delete()
      .eq('id', pouleId)

    if (error) throw error
    setPoules(poules.filter(p => p.id !== pouleId))
  }

  return { poules, loading, createPoule, deletePoule, refetch: fetchPoules }
}
